/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TwitterThreadLayout} from "../../layouts/TwitterThreadLayout";
import {TwitterThreadBlock, TwitterThreadAuthor, TwitterThreadOriginalUrl, TwitterThreadBlockFirst} from "../../components/TwitterThread";
export const meta = {
  url: "https://devsforgood.com/thread/handmade-javascript-notes-and-cheat-sheets",
  title: "Handmade JavaScript notes and cheat sheets",
  description: `Some of my handmade JavaScript notes and cheat sheets that can help you 🧵👇`,
  image: "/covers/threads/handmade-javascript-notes-and-cheat-sheets.png",
  author: "Pratham"
};
const MDXLayout = ({children}) => _jsx(TwitterThreadLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    ol: "ol",
    li: "li",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(TwitterThreadAuthor, {
      name: "Pratham",
      username: "Prathkum",
      avatarUrl: "/avatars/Prathkum.png"
    }), "\n", _jsx(TwitterThreadOriginalUrl, {
      url: "https://twitter.com/Prathkum/status/1394733122911039490"
    }), "\n", _jsx(TwitterThreadBlockFirst, {
      image: `undefined`,
      children: _jsx(_components.p, {
        children: "Some of my handmade JavaScript notes and cheat sheets that can help you 🧵👇"
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handmade-javascript-notes-and-cheat-sheets-1.png`,
      children: _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "JavaScript Function Anatomy"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handmade-javascript-notes-and-cheat-sheets-2.png`,
      children: _jsxs(_components.ol, {
        start: "2",
        children: ["\n", _jsx(_components.li, {
          children: "JavaScript Arrow Function"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handmade-javascript-notes-and-cheat-sheets-3.png`,
      children: _jsxs(_components.ol, {
        start: "3",
        children: ["\n", _jsx(_components.li, {
          children: "JavaScript Array Methods"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handmade-javascript-notes-and-cheat-sheets-4.png`,
      children: _jsxs(_components.ol, {
        start: "4",
        children: ["\n", _jsx(_components.li, {
          children: "JavaScript Date Methods"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handmade-javascript-notes-and-cheat-sheets-5.png`,
      children: _jsxs(_components.ol, {
        start: "5",
        children: ["\n", _jsx(_components.li, {
          children: "JavaScript Array Methods"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handmade-javascript-notes-and-cheat-sheets-6.png`,
      children: _jsxs(_components.ol, {
        start: "6",
        children: ["\n", _jsx(_components.li, {
          children: "Event Loop"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handmade-javascript-notes-and-cheat-sheets-7.png`,
      children: _jsxs(_components.ol, {
        start: "7",
        children: ["\n", _jsx(_components.li, {
          children: "JavaScript DOM Methods"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handmade-javascript-notes-and-cheat-sheets-8.png`,
      children: _jsxs(_components.ol, {
        start: "8",
        children: ["\n", _jsx(_components.li, {
          children: "DOM addEventListerner Method"
        }), "\n"]
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/handmade-javascript-notes-and-cheat-sheets-9.png`,
      children: _jsx(_components.p, {
        children: "More than 0.5 million views on this tweet ❤️🔥"
      })
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/handmade-javascript-notes-and-cheat-sheets-10.png`,
      children: [_jsx(_components.p, {
        children: "Check it here in action"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://www.buymeacoffee.com/prathkum",
          children: "https://www.buymeacoffee.com/prathkum"
        })
      })]
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
